<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <cm-navbar title="Not found"></cm-navbar>

                <f7-block strong>
                    <p>Sorry</p>
                    <p>Requested content not found.</p>
                </f7-block>
            </f7-page>
        </f7-view>
    </transition>
</template>
<script>
    import CMNavbar from './Navbar'

    export default {
        components: {
            'cm-navbar': CMNavbar,
        }
    };
</script>